import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { API_URL } from "../../../src/Constant.js";
import AdminNavbar from "./AdminLayout/AdminNavbar";
import AdminFooter from "./AdminLayout/AdminFooter";
import AdminSidebar from "./AdminLayout/AdminSidebar";
import { Container, Card, Table } from "react-bootstrap";

const AdminCounsellorList = () => {
  const navigate = useNavigate();
  const [adminCounsellorList, setAdminCounsellorList] = useState([]);
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    fetchAdminCounsellorList();
    updateCurrentTime();
  }, []);

  const fetchAdminCounsellorList = async () => {
    try {
      const response = await fetch(
        API_URL + "api/Admin/GetAdminCounsellorList"
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      console.log("Fetched Counsellor List:", data.data);

      if (data && Array.isArray(data.data)) {
        setAdminCounsellorList(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setAdminCounsellorList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateCurrentTime = () => {
    const now = new Date();
    setCurrentTime(now.toLocaleString());
  };

  return (
    <div>
      <AdminNavbar />
      <div className="d-flex">
        {/* <AdminSidebar /> */}
        <Container fluid className="p-4">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            {" "}
            <h1 className="cheading">Admin Counsellor List</h1>
            <span
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#333",
              }}
            >
              📅 {currentTime}
            </span>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <Table striped bordered hover>
                    <thead
                      style={{ alignContent: "center", textAlign: "center" }}
                    >
                      <tr style={{ verticalAlign: "middle" }}>
                        <th>Sr. No.</th>
                        <th style={{ textAlign: "left" }}>Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                        <th style={{ textAlign: "left" }}>Country</th>
                        <th>Date of Birth</th>
                        <th>Gender</th>
                        <th>Experience (Years)</th>
                        <th>Resume</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody
                      style={{ alignContent: "center", textAlign: "center" }}
                    >
                      {adminCounsellorList.length > 0 ? (
                        adminCounsellorList.map((counsellor, index) => (
                          <tr key={counsellor.id}>
                            <td>{index + 1}</td>
                            <td style={{ textAlign: "left" }}>
                              {counsellor.counsellorName}
                            </td>
                            <td>{counsellor.emailId}</td>
                            <td>{counsellor.mobileNo}</td>
                            <td style={{ textAlign: "left" }}>
                              {counsellor.countryName}
                            </td>
                            <td>{counsellor.dateOfBirth}</td>
                            <td>{counsellor.gender}</td>
                            <td>{counsellor.yearsOfExperience}</td>
                            <td>
                              {counsellor.resumeFileUrl ? (
                                <a
                                  href={counsellor.resumeFileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-success"
                                  style={{
                                    padding: "1px 5px",
                                    marginLeft: "10px",
                                    color: "white",
                                  }}
                                >
                                  View
                                </a>
                              ) : (
                                <span style={{ color: "gray" }}>No Resume</span>
                              )}
                            </td>

                            <td>
                              <button
                                type="button"
                                className="btn btn-primary"
                                style={{
                                  padding: "1px 5px",
                                  marginLeft: "10px",
                                  color: "white",
                                }}
                              >
                                All Details
                              </button>{" "}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">No counsellors found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <AdminFooter />
    </div>
  );
};

export default AdminCounsellorList;
